module.exports = "<angular-loader></angular-loader>\n<router-outlet></router-outlet>\n"